<template>
  <v-container v-if="filter">
    <report
      title="Overall Score"
      :filter="filter"
      :team="team"
      :manager="manager"
      :user="user"
      v-on:refreshData="refreshData"
      v-on:rowClick="rowClick"
      :headers="headers"
      :loading="list_loading"
      :items="items"
      :show-table="showTable"
      enable-business-metrics
    >
      <v-card-text class="py-0">
        <loading-spinner v-if="trend_loading"> </loading-spinner>
        <template v-else>
          <trend-chart
            :loading="trend_loading"
            :height="250"
            round
            reverse
            label="Overall Score"
            enable-business-metrics
          ></trend-chart>
          <v-row
            v-if="
              overall_score.overview &&
                overall_score.overview.score &&
                overall_score.overview.score.value
            "
          >
            <report-overall-card
              label="Overall Score"
              :value="overall_score.overview.score.value | no_decimal"
              :color="
                $coreScores.getColor(
                  this.$coreScores.reverseFormat(
                    overall_score.overview.score.value
                  )
                )
              "
            >
              <template v-slot:prepend>
                <v-img
                  :src="
                    $coreScores.getOverallImage(
                      overall_score.overview.score.value
                    )
                  "
                ></v-img>
              </template>
              <template v-slot:valueExtension>
                <compare-text
                  align-end
                  ignore-margin
                  :old-value="overall_score.overview.score.compare"
                  :new-value="overall_score.overview.score.value"
                  :timeframeId="filter.timeframeId"
                >
                </compare-text>
              </template>
              <div class="caption lighttext--text">
                This score is
                <span
                  v-bind:style="{
                    color: $coreScores.getColor(
                      this.$coreScores.reverseFormat(
                        overall_score.overview.score.value
                      )
                    )
                  }"
                  >{{
                    $coreScores.getTitle(
                      this.$coreScores.reverseFormat(
                        overall_score.overview.score.value
                      )
                    )
                  }}</span
                >
              </div>
            </report-overall-card>
          </v-row>
        </template>
        <v-tabs v-model="tab" v-if="showTable">
          <v-tab :class="{ 'd-none': filter.managerId }">
            Departments
          </v-tab>
          <v-tab
            :class="{
              'd-none':
                filter.managerId ||
                (overall_score &&
                  overall_score.overview &&
                  overall_score.overview.hideManagers)
            }"
          >
            Teams
          </v-tab>
          <v-tab>
            Members
          </v-tab>
        </v-tabs>
      </v-card-text>
    </report>
  </v-container>
</template>

<script>
import Report from "@/components/reporting/Report";
import { mapGetters } from "vuex";
import TrendChart from "@/components/reporting/TrendChart";
import CompareText from "@/components/reporting/CompareText";
import ReportOverallCard from "@/components/reporting/ReportOverallCard";
import reports from "@/helpers/mixins/reports";
export default {
  name: "OverallScoreReport",
  props: {
    filter: { type: Object },
    team: { type: Object },
    manager: { type: Object },
    user: { type: Object }
  },
  mixins: [reports],
  components: {
    TrendChart,
    ReportOverallCard,
    CompareText,
    Report
  },
  data: () => ({
    list_loading: false,
    trend_loading: false,
    tab: 0
  }),
  watch: {
    tab(val, oldVal) {
      if (val != oldVal) {
        this.getList();
      }
    },
    filter(val, oldVal) {
      if (!oldVal && val != null) {
        this.update();
      }
    }
  },
  computed: {
    showTable() {
      return !this.filter.userId && this.settings.isReviewActive;
    },
    headers() {
      let items = [
        { text: "Name", value: "name" },
        { text: "Overall Score", value: "score.value" }
      ];

      if (this.filter.timeframeId != this.$enums.timeframes.ALL_TIME) {
        items.push({
          text: "Trend",
          value: "score.percentChange"
        });
      }

      items.push({ text: "", value: "actions" });

      return items;
    },
    items() {
      let data = [];
      switch (this.tab) {
        case 0:
          data = this.overall_score.teams;
          break;
        case 1:
          data = this.overall_score.managers;
          break;
        case 2:
          data = this.overall_score.members;
          break;
      }
      return data || [];
    },
    ...mapGetters({
      overall_score: "reporting/overall_score",
      settings: "profile/settings"
    })
  },
  created() {
    if (this.filter != null) {
      this.update();
    }
  },
  methods: {
    rowClick(item) {
      let link = this.getLink(item);
      if (!link) {
        return;
      }
      this.$router.push({ path: link });
    },
    update() {
      this.refreshData();
    },
    getList() {
      let action = this.getAction();
      if (!action) {
        return;
      }
      this.list_loading = true;
      Promise.all([this.$store.dispatch(action, this.filter)])
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading report."
          );
        })
        .finally(() => {
          this.list_loading = false;
        });
    },
    getAction() {
      if (!this.showTable) {
        return "";
      }
      switch (this.tab) {
        case 0:
          return "reporting/getOverallScoreTeams";
        case 1:
          return "reporting/getOverallScoreManagers";
        default:
          return "reporting/getOverallScoreMembers";
      }
    },
    refreshData() {
      this.$store.dispatch("reporting/clearOverallScore").then(() => {
        this.list_loading = true;
        this.trend_loading = true;
        Promise.all([
          this.$store.dispatch("reporting/getOverallScore", this.filter),
          this.$store.dispatch("reporting/getOverallScoreTrend", this.filter)
        ])
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occured while loading report."
            );
          })
          .finally(() => {
            this.list_loading = false;
            this.trend_loading = false;
          })
          .then(() => {
            let newTab = this.getInitialTab(this.overall_score.overview);
            if (newTab) {
              this.tab = newTab;
            }
            this.getList();
          });
      });
    }
  }
};
</script>
